import _ from 'lodash';
import { isNavItemShown } from './helpers';

const listNav = [{
  path: '/',
  title: 'Homepage',
}, {
  path: '/careers',
  title: 'Careers',
}, {
  path: '/blog',
  title: 'Blog',
}];

export default _.filter(listNav, isNavItemShown);



// WEBPACK FOOTER //
// ./src/config/listNav.js